import { useState, useEffect } from "react";
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../lib/config';
import { AuthTokenResponse } from "@supabase/supabase-js";
import { useAuthStep } from "./useAuthStep";
import { CredentialResponse } from "@react-oauth/google";

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);


export const useGoogleAuth = () => {

    const [credentialResponse, setCredentialResponse] = useState({});
    const [success, setSuccess] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const { setToken } = useAuthStep();


    const googleLogin = async (tokenResponse: CredentialResponse) => {
        try {

            setLoading(true);
            setError(null);
            localStorage.setItem("last_used_login_method", "google");

            // Use signInWithIdToken to exchange the Google credential for a Supabase session
            return supabase.auth.signInWithIdToken({
                provider: 'google',
                token: tokenResponse?.credential,
                /*
                options: {
                    scopes: 'openid email profile https://www.googleapis.com/auth/user.birthday.read',
                }
                    */
            });


        } catch (err) {
            console.error('Login error:', err);
            setError('An unexpected error occurred during login. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return {
        success,
        error,
        loading,
        googleLogin,
    }
}
